module.exports = __webpack_public_path__ + "img/sg.725f878.svg";